import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initSentry } from "./lib/sentry";
import { initPlausible } from "./lib/plausible";
import { trackLaunchVisit } from "./lib/launch-funnel";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import inter400Woff2 from "@fontsource/inter/files/inter-latin-400-normal.woff2?url";
import inter600Woff2 from "@fontsource/inter/files/inter-latin-600-normal.woff2?url";
import "./index.css";

// Sentry init runs before React renders so the very first React error lands
// in Sentry too (instead of only the browser console). No-op when the DSN
// env var is unset — see lib/sentry.ts.
initSentry();
// Plausible appends its `<script>` tag when `VITE_PLAUSIBLE_DOMAIN` is set.
// No-op otherwise — see lib/plausible.ts.
initPlausible();
trackLaunchVisit();
ensureFontPreload(inter400Woff2);
ensureFontPreload(inter600Woff2);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

function ensureFontPreload(href: string) {
  if (!href || document.head.querySelector(`link[rel="preload"][href="${href}"]`)) {
    return;
  }
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "font";
  link.type = "font/woff2";
  link.crossOrigin = "anonymous";
  link.href = href;
  document.head.appendChild(link);
}
